import { ClearanceItemAssetManagerComponent } from '../asset-management/clearance-item-asset-manager.component';
import { Component, Input, EventEmitter, Output, ViewChild, OnInit, ChangeDetectorRef } from '@angular/core';
import { ClearanceItem, CIAsset } from '../clearance-item.model';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { NotificationsService, Notification } from '../../shared/helper-components/index'
import { ClearanceItemTagComponent } from '../clearance-item-tag.component';
import { ClearanceItemGroupNameComponent } from './clearance-item-groupname.component';
import { PENDING_STATUSES } from '../../shared/helper-components/constants';

type callBackWhenDone = (data: any) => void;

@Component({
    selector: 'bulk-actions',
    standalone: false,
    templateUrl: './clearance-item-bulk.component.html',
    styleUrls: ['./clearance-item-bulk.component.css']
})
export class ClearanceItemBulkComponent implements OnInit {

    @ViewChild('groupName', { static: false }) groupNameComponent: ClearanceItemGroupNameComponent;
    @ViewChild('imageAsset', { static: false }) imageComponent: ClearanceItemAssetManagerComponent;
    @ViewChild('tagComponent', { static: false }) tagComponent: ClearanceItemTagComponent;
    @ViewChild('documentAsset', { static: false }) documentComponent: ClearanceItemAssetManagerComponent;

    @Input()
    itemList: ClearanceItem[] = [];
    @Input()
    projectId: string;
    @Input('modalId')
    set currentModal(value: string) {
        if (value) {
            this.activeModal = value;
        }
    }

    activeModal: string = null;
    @Input()
    dataList: object[];
    @Output()
    bulkActionUpdated: EventEmitter<callBackWhenDone> = new EventEmitter<callBackWhenDone>();
    @Input('isClearanceUser')
    public isClearanceUser: boolean;

    masssUpdateForm: FormGroup;
    bulkForm: FormGroup;
    commentIsRequired: boolean;
    showComments = false;

    callBackWhenDone: callBackWhenDone;

    constructor(private _fb: FormBuilder,
        private _notificationsService: NotificationsService,
        private _cdr: ChangeDetectorRef
    ) {
    }

    ngOnInit(): void {
        this.bulkForm = this._fb.group({});
    }

    setForm(form: FormGroup) {
        this.bulkForm = form;
    }

    initializeModal(modalName: string, callback: callBackWhenDone): void {
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {
            this.activeModal = modalName;
            this.callBackWhenDone = callback;
            this._cdr.detectChanges();
            setTimeout(() => {
                if (this.groupNameComponent) {
                    this.groupNameComponent.initForm();
                    this.groupNameComponent.setFocus();
                }
                if (this.tagComponent) {
                    this.tagComponent.initItemForm(true);
                }
                if (this.imageComponent) {
                    this.imageComponent.initItemForm([], true);
                }
                if (this.documentComponent) {
                    this.documentComponent.initItemForm([], true);
                }
            });
        }
    }

    closeModal(): void {
        this.activeModal = null;
        this._cdr.detectChanges();
    }

    onGroupNameUpdate(groupName: FormGroup) {
        this.callBack(groupName);
    }

    addImages(): void {
        let selectedImages = this.imageComponent.getSelectedAssets();
        this.callBack(selectedImages);
    }

    addTags(): void {
        let selectedTags = this.tagComponent.getSelectedTags();
        this.callBack(selectedTags);
    }

    newTagAdded(tag: FormGroup): void {
        if (tag) {
            tag.controls.isSelected.setValue(!tag.controls.isSelected.value);
        }
    }

    addDocuments(): void {
        let selectedDocs = this.documentComponent.getSelectedAssets();
        this.callBack(selectedDocs);
    }

    changeStatus() {
        if (!this.bulkForm.valid) {
            this._notificationsService.add(new Notification('warn', 'Please enter comments (min 3 characters) to update the status, or click cancel to undo your changes.', 'Comments needed'));
            return;
        }
        this.callBack(this.bulkForm);
    }

    callBack(data: any) {
        if (this.callBackWhenDone) {
            this.callBackWhenDone(data);
            this.closeModal();
        }
    }

    get tagsCanBeEdited(): boolean {
        let selectedItems = this.itemList.filter(it => it.isSelected);
        return selectedItems.length > 0 && (
            this.isClearanceUser || selectedItems.every(it => PENDING_STATUSES.has(it.status.toUpperCase()))
        );
    }
}
